import { useEffect } from 'react';

/** Sets `document.title` with an Aakash Drishti suffix. */
export default function usePageTitle(title) {
  useEffect(() => {
    const brand = 'Aakash Drishti';
    document.title = title ? `${title} · ${brand}` : `${brand} · Satellite Intelligence for Critical Infrastructure`;
  }, [title]);
}
